import {
  ApplicationInsights,
  DistributedTracingModes,
} from "@microsoft/applicationinsights-web";
import { ReactPlugin } from "@microsoft/applicationinsights-react-js";

const appInsightsPlugin = new ReactPlugin();
const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey:
      process.env.REACT_APP_APPLICATION_INSIGHTS_INSTRUMENTATION_KEY,
    extensions: [appInsightsPlugin],
    disableFetchTracking: false,
    enableAutoRouteTracking: true,
    enableCorsCorrelation: true,
    enableRequestHeaderTracking: true,
    enableResponseHeaderTracking: true,
    distributedTracingMode: DistributedTracingModes.W3C,
    extensionConfig: {
      [appInsightsPlugin.identifier]: {},
    },
  },
});

try {
  appInsights.loadAppInsights();
} catch (ex) {
  console.warn("Failed to load app insights", ex);
}

export { appInsightsPlugin };
